
import StageManager from "../../../../../shared/lib/html5-software-library/src/ranj/performance/StageManager";
import Task from "../../../../../shared/lib/html5-software-library/src/ranj/util/executor/Task";
import { applySearchParametersToObject, getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import AssetLibrary from "../../../../../shared/src/ranj/app/assetloading/AssetLibrary";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import SaveEvent from "../../../../../shared/src/ranj/equalture/savegame/SaveEvent";
import { getSeededPRNG } from "../../../../../shared/src/ranj/util/RandomUtil";
import GameConfig from "../model/GameConfig";
import GameModel from "../model/GameModel";
import GameElementSkinFactory from "../view/GameElementSkinFactory";

export default class InitWorkingMemoryGameTask extends Task {

    /**
     * @param {AssetLibrary} assetLibrary 
     * @param {GameConfig} gameConfig 
     * @param {GameModel} gameModel 
     * @param {StageManager} stageManager
     */
    constructor(dispatcher, assetLibrary, gameConfig, gameModel, stageManager, gameElementSkinFactory) {
        super();

        this.execute = function(callback, progressCallback) {

            if (AppModel.isMobile) {
                stageManager.setAllStagesFramerate(30);
            }

            // Check if all locations have all spots
            // TODO: move this to test script
            // const missingSpots = [];
            // Array.from(new Set(gameConfig.getValue("randomizedPuzzles").map(cfg=>cfg.locations).concat(gameConfig.getValue("randomizedPracticePuzzles").map(cfg=>cfg.locations)).flat()))
            //     .forEach((location, index) => {
            //         const elem = gameElementSkinFactory.getLocation(location);
            //         for (let i = 1; i < 8; i++) {
            //             let spotId = `spot${i}`;
            //             const spotMC = elem[spotId];
            //             if (!spotMC) {
            //                 missingSpots.push({ location, spotId });
            //             }
            //         }
            //     });
            // if (missingSpots.length > 0) {
            //     console.error("Missing spots in locations:\n", JSON.stringify(missingSpots,null,2));
            // } else {
            //     console.log("All spots are available in all locations.");
            // }

            gameModel.initialize();
            const lvl = parseInt(getURLParameter("level"));
            if (!isNaN(lvl)) {
                gameModel._puzzleIndex = Math.max(lvl - 2, -1);
            }

            if (ranj.DEBUG) {
                window.gameconfig = gameConfig;
                window.gamemodel = gameModel;
            }

            callback(this);
        }

        this._handleKeyUp = function(e) {
            const c = String.fromCharCode(e.which);
            if (c == "R") {
                if (confirm("Are you sure you want to reset the savegame?")) {
                    dispatcher.dispatch(SaveEvent.CLEAR);
                    window.location.reload();
                }
            }
        }.bind(this);


        document.addEventListener("visibilitychange", _ => {
            console.log("Event: visibilitychange. Hidden: " + document.hidden);
            createjs.Ticker.paused = document.hidden;
        });
    }




}
